import i18n from 'i18next';
import { isEmpty } from 'lodash';

export class InvalidParameterTranslator {
  private readonly invalidParameters: string[];

  constructor(invalidParameters: string[]) {
    this.invalidParameters = invalidParameters;
  }

  public static create(invalidParameters: string[]): InvalidParameterTranslator {
    return new InvalidParameterTranslator(invalidParameters);
  }

  public getDescription(): string {
    if (isEmpty(this.invalidParameters)) {
      throw new Error('Could not find any invalid parameter');
    }
    return this.invalidParameters.map(param => i18n.t(`invalid-parameter_${param}`)).join('<br>');
  }

  public getErrors(): string[] {
    if (isEmpty(this.invalidParameters)) {
      throw new Error('Could not find any invalid parameter');
    }
    return this.invalidParameters.map(param => i18n.t(`invalid-parameter_${param}`));
  }
}
